import { render, staticRenderFns } from "./redes.vue?vue&type=template&id=14e12a18&"
import script from "./redes.vue?vue&type=script&lang=js&"
export * from "./redes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports